'use client';

import { useMetrica } from 'next-yandex-metrica';
import { useCallback, useMemo } from 'react';

import { toCareerOfferAttributionParameters } from '../model/analytics-attribution';
import {
	trackCareerOfferEvent,
	trackCareerOfferGoal,
	trackCareerOfferHit,
	type CareerOfferEvent,
	type CareerOfferGoal,
} from '../model/events';
import { useCareerOfferAttribution } from './career-offer-attribution-provider';

export const useCareerOfferAnalytics = () => {
	const metrica = useMetrica();
	const attribution = useCareerOfferAttribution();

	const trackEvent = useCallback(
		(event: CareerOfferEvent) => {
			trackCareerOfferEvent(
				metrica,
				event,
				toCareerOfferAttributionParameters(attribution),
			);
		},
		[attribution, metrica],
	);

	const trackGoal = useCallback(
		(goal: CareerOfferGoal, event: CareerOfferEvent) => {
			trackCareerOfferGoal(
				metrica,
				goal,
				event,
				toCareerOfferAttributionParameters(attribution),
			);
		},
		[attribution, metrica],
	);
	const trackHit = useCallback(
		(url: string) => trackCareerOfferHit(metrica, url),
		[metrica],
	);

	return useMemo(
		() => ({ trackEvent, trackGoal, trackHit }),
		[trackEvent, trackGoal, trackHit],
	);
};
